import React, { useEffect } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import Layout from './Layout';
import { getLoader } from './apiServices/request';
function App() {

  useEffect(() => {
    getLoader("none");
  }, [])

  return (
      <>
        <Layout />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
          onClick={() => {}}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </>
  );
}

export default App;

